export default __webpack_public_path__ + "static/media/litens.db1904fe.jpeg";